module.exports = __webpack_public_path__ + "static/media/corporate-services-img8.d3f10af9.jpg";